"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var component_library_1 = require("@kaizen/component-library");
var typography_1 = require("@kaizen/typography");
var exclamation_white_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/exclamation-white.icon.svg"));
var classnames_1 = __importDefault(require("classnames"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
var WarningIcon = function () { return (React.createElement("span", { className: styles_scss_1["default"].warningIcon },
    React.createElement(component_library_1.Icon, { icon: exclamation_white_icon_svg_1["default"], title: "Error message", role: "img", inheritSize: false }))); };
var FieldMessage = function (_a) {
    var _b;
    var id = _a.id, automationId = _a.automationId, message = _a.message, _c = _a.status, status = _c === void 0 ? "default" : _c, _d = _a.reversed, reversed = _d === void 0 ? false : _d, _e = _a.position, position = _e === void 0 ? "bottom" : _e;
    var textColor = status === "default"
        ? reversed
            ? "white-reduced-opacity"
            : "dark-reduced-opacity"
        : "dark";
    return (React.createElement("div", { id: id, "data-automation-id": automationId, className: (0, classnames_1["default"])(styles_scss_1["default"].message, styles_scss_1["default"][status], (_b = {},
            _b[styles_scss_1["default"].reversed] = reversed,
            _b[styles_scss_1["default"].positionBottom] = position === "bottom",
            _b[styles_scss_1["default"].positionTop] = position === "top",
            _b)) },
        (status === "error" || status === "caution") && React.createElement(WarningIcon, null),
        React.createElement("div", { className: styles_scss_1["default"].message },
            React.createElement(typography_1.Paragraph, { variant: "small", color: textColor }, message))));
};
exports["default"] = FieldMessage;
//# sourceMappingURL=FieldMessage.js.map